import { useCallback } from "react";
import { CustomFormLabel, CustomTextField } from "../formsComponents";
import { ITextFieldWithLabelProps } from "./TextFieldWithLabel.types";

export const TextFieldWithLabel: React.FC<ITextFieldWithLabelProps> = (
  props,
) => {
  return (
    <>
      {props.heading && <CustomFormLabel>{props.heading}</CustomFormLabel>}
      <CustomTextField
        {...props}
        variant="outlined"
        size="small"
        error={!!props.error}
        helperText={props.error ? props.helperText : ""}
      />
    </>
  );
};

//##############################################################################################
//################################### Mui Number Field ######################################
//##############################################################################################
interface IMuiNumberFieldProps
  extends Omit<ITextFieldWithLabelProps, "value" | "id"> {
  id: string;
  value?: string | number;
}
export const MuiNumberFieldWithLabel: React.FC<IMuiNumberFieldProps> = (
  props,
) => {
  const { id, value, size, error, placeholder, type, onChange } = props;

  // Process Initial Value
  const processedValue = useCallback(() => {
    if (value === undefined || value === null || value === "") return "";
    const valStr = value.toString();

    if (valStr.startsWith("0.") || valStr === "0") {
      return valStr; // Keep "0." and "0"
    }

    return valStr.replace(/^0+/, ""); // Remove leading zeros from integers
  }, [value])();

  return (
    <TextFieldWithLabel
      name={id}
      variant={props.variant ? props.variant : "outlined"}
      size={size ? size : "small"}
      fullWidth
      value={processedValue}
      placeholder={placeholder ? placeholder : "0"}
      onChange={(event) => {
        if (!props.onChange) return;

        let newValue = event.target.value
          .replace(/[^0-9.]/g, "") // Allow digits and dot
          .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

        // If value starts with '0.' or is exactly "0", keep as is. Else, strip leading zeros.
        if (!newValue.startsWith("0.") && newValue !== "0") {
          newValue = newValue.replace(/^0+/, "");
        }

        props.onChange({
          ...event,
          target: { ...event.target, id, value: newValue },
        });
      }}
      error={!!error}
      helperText={error}
      {...props}
      // InputProps={props.adornment ? {
      //     [props.adornmentPosition === "end" ? "endAdornment" : "startAdornment"]: (
      //         <InputAdornment position={props.adornmentPosition === "end" ? "end" : "start"}>
      //             {typeof props.adornment === "string" ?
      //                 <Box component="span" sx={{ color: 'text.disabled' }}>
      //                     {props.adornment}
      //                 </Box>
      //                 : props.adornment
      //             }
      //             {/* <Iconify icon={props.adornment as React.ReactNode} /> */}
      //         </InputAdornment>
      //     ),
      // } : props.InputProps}
    />
  );
};
